import { getCustomer } from "../../../../../util/user";

export const initialState = {
  customer: getCustomer(),
};

export default initialState;
